import { Injectable } from '@angular/core';
import { ApiMethodConstants } from './common/api-method.constants';
import { DataRefreshDate, ILocationService, LocationItem, LocationsRequest } from './common/locations.model';
import { HccnLocationsService } from './hccn-locations/hccn-locations.service';
import { HealthCenterLocationsService } from './health-center-locations/health-center-locations.service';
import { ImmigrantLocationsService } from './immigrant-locations/immigrant-locations.service';
import { LocationStateService } from './location-state.service';
import { OrganTransplantLocationsService } from './organ-transplant/organ-transplant.service';
import { RyanWhiteLocationsService } from './ryan-white/ryan-white.service';
import { ToolIdentifierService } from './tool-identifier';
import { LocatorTools } from './tool-identifier/locator-tools.enum';

/* A factory for controlling which locator tool web service is called when calling web services, like for searching. */
@Injectable()
export class LocationFactoryService {
  // store a reference to the enum to use in the template
  locatorTools = LocatorTools;
  locationService: ILocationService;
  private locatorTool: LocatorTools;

  constructor(
    private toolIdentifier: ToolIdentifierService,
    private healthCenterService: HealthCenterLocationsService,
    private organTransplantService: OrganTransplantLocationsService,
    private hccnService: HccnLocationsService,
    private mshsService: ImmigrantLocationsService,
    private ryanWhiteService: RyanWhiteLocationsService,
    private locationStateService: LocationStateService
  ) {
    this.locatorTool = this.toolIdentifier.getCurrentTool();
    switch (this.locatorTool) {
      case this.locatorTools.HealthCenter:
        this.locationStateService.ApiMethod = ApiMethodConstants.HealthCenters;
        this.locationService = this.healthCenterService;
        break;
      case this.locatorTools.OrganTransplantCenter:
        this.locationStateService.ApiMethod = ApiMethodConstants.Opo;
        this.locationService = this.organTransplantService;
        break;
      case this.locatorTools.HealthCenterControlledNetwork:
        this.locationStateService.ApiMethod = ApiMethodConstants.Hccn;
        this.locationService = this.hccnService;
        break;
      case this.locatorTools.MigrantSeasonalHeadStart:
        this.locationStateService.ApiMethod = ApiMethodConstants.Mshs;
        this.locationService = this.mshsService;
        break;
      case this.locatorTools.HIVMedicalProvider:
        this.locationStateService.ApiMethod = ApiMethodConstants.RyanWhite;
        this.locationService = this.ryanWhiteService;
        break;
      default:
        this.locationService = this.healthCenterService;
        break;
    }
  }

  /* Find locations within a radius of a location.*/
  public getLocations(request: LocationsRequest): Promise<LocationItem[]> {
    return this.locationService.getLocations(request);
  }

  public getRefreshDate(): Promise<DataRefreshDate> {
    return this.healthCenterService.getRefreshDate();
  }

  public getMSHSRefreshDate(): Promise<DataRefreshDate> {
    return this.healthCenterService.getMSHSRefreshDate();
  }

  /* Get the file name for the Excel download, without the extension.*/
  public getExcelFileName(): string {
    var date = new Date();
    var month = (date.getMonth() + 1).toString();
    if (month.length < 2) {
      month = '0' + month;
    }
    var day = date.getDate().toString();
    if (day.length < 2) {
      day = '0' + day;
    }
    var fileName = 'Health-Centers';
    switch (this.locatorTool) {
      case this.locatorTools.OrganTransplantCenter:
        fileName = 'OPO';
        break;
      case this.locatorTools.HealthCenterControlledNetwork:
        fileName = 'HCCN';
        break;
      case this.locatorTools.MigrantSeasonalHeadStart:
        fileName = 'MSHS';
        break;
      case this.locatorTools.HIVMedicalProvider:
        fileName = 'HAB';
        break;
    }
    return fileName + '-' + month + '-' + day + '-' + date.getFullYear();
  }
}
